import React, { createContext, useContext } from 'react';

const PermissionContext = createContext(null);

export const PermissionProvider = ({ children, permissions = [] }) => {
    // If user is super admin (role_name: 'Super Admin'), they have all permissions
    // But for safety, we rely on the backend provided list.
    // If permissions array includes '*', allow everything (optional design choice).

    const hasPermission = (requiredPermission) => {
        if (!permissions) return false;
        // Check for specific permission or if user is admin (optional, depends on design)
        return permissions.includes(requiredPermission);
    };

    const hasAnyPermission = (requiredPermissions) => {
        if (!permissions) return false;
        return requiredPermissions.some(permission => permissions.includes(permission));
    };

    return (
        <PermissionContext.Provider value={{ permissions, hasPermission, hasAnyPermission }}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermission = () => {
    const context = useContext(PermissionContext);
    if (!context) {
        throw new Error('usePermission must be used within a PermissionProvider');
    }
    return context;
};

// Component helper for conditional rendering
export const HasPermission = ({ code, children, fallback = null }) => {
    const { hasPermission } = usePermission();

    if (hasPermission(code)) {
        return <>{children}</>;
    }

    return fallback;
};

export default PermissionContext;
